/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import $ from 'jquery';
import uiComponent from 'uiComponent';
import url from 'mage/url';
import 'Magento_Ui/js/modal/modal';
import customerData from 'Magento_Customer/js/customer-data';
import templateEngine from 'mage/template';
import mobileNavTmpl from 'text!Vaimo_Mmi/template/mobile-nav-link.html';

export default uiComponent.extend({
    defaults: {
        desktopNavigation:  $('.v-navigation.v-navigation--mega'),
        sectionUrl: url.build('freedevice/view/'),
        categoryName: 'Free Device',
    },

    initialize: function () {
        this._super();

        if (customerData.get('customer')().firstname === undefined) {
            customerData.get('customer').subscribe(() => {
                if (customerData.get('customer')().free_device_qty) {
                    this.showMenu();
                }
            });
        } else {
            if (customerData.get('customer')().free_device_qty) { // eslint-disable-line no-lonely-if
                this.showMenu();
            }
        }
    },

    showMenu: function () {
        var config = {
                categoryName: this.categoryName,
                categoryUrl: this.sectionUrl
            },
            $html = $(templateEngine(mobileNavTmpl, config));

        if (!this.desktopNavigation.find('.nav-freedevice').length) {
            this.desktopNavigation.append($html);
        }
    }
});
